<template>
  <div class="returnsAndReclamations">
    <h3 class="returnsAndReclamations-title">Zwroty i reklamacje</h3>
    <div class="returnsAndReclamations-download">
      <span class="download">Pobierz protokół reklamacji i zwrotów</span>
      <p>W razie potrzeby zwrócenia lub reklamacji produktu prosimy o kontakt z naszym działem sprzedaży pod numerem tel. 22 726 50 50.</p>
      <p>Przed złożeniem reklamacji prosimy o przygotowanie informacji o numerze faktury lub dokumentu wydania, na podstawie którego wydany został dany produkt.</p>
      <p>Uwaga! Ze względu na konieczność utrzymania łańcucha temperatur, produkty które należy przechowywać w temperaturze lodówkowej nie podlegają zwrotom</p>
    </div>
  </div>
</template>

<script>
import FileDocumentIcon from "vue-material-design-icons/FileDocument.vue";

export default {
  name: "ReturnsPage",
  components: {
    FileDocumentIcon,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/template/ReturnsPage.vue